import React from 'react';
import Link from 'next/link';
import data from '../data/pages/cookie-policy.yml';
import Terms from '../client/templates/common/terms/Terms';
import AppLayout from '../client/layouts/app-layout/AppLayout';
import PageHead from '../client/components/page-head/PageHead';

const {
  SEO,
} = data;

export default () => (
  <AppLayout>
    <PageHead SEO={SEO} />

    <Terms>
      <div>
        <section>
          <h1>
            COOKIE POLICY
          </h1>

          <p>
            Ai sensi della vigente normativa in materia di protezione dei dati personali (&quot;<strong>Normativa Privacy</strong>&quot;),
            incluso in Reg. UE 2016/679 (&quot;<strong>GDPR</strong>&quot;) e il Provvedimento del Garante per la protezione dei dati personali (&quot;<strong>Garante Privacy</strong>&quot;)
            n. 229/2014 sull&apos;individuazione delle modalità semplificate per l&apos;informativa e l&apos;acquisizione del consenso per l&apos;uso dei <em>cookie</em>, DOVE.IT,
            in qualità di titolare del trattamento (il &quot;<strong>Titolare</strong>&quot;) fornisce le seguenti informazioni relative ai cookie installati sul sito web <Link href="/">www.dove.it</Link> (il &quot;<strong>Sito</strong>&quot;).
          </p>
        </section>

        <section>
          <h2>
            Cosa sono i cookie
          </h2>

          <p>
            I <em>cookie</em> sono delle porzioni di testo che vengono trasferite sul computer dell&apos;utente, dai siti <em>web</em> consultati dallo stesso tra cui il Sito.
            Di norma sono utilizzati per garantire un buon funzionamento del sito e una maggiore efficienza nella navigazione, poiché
            consentono di ricordare e comunicare informazioni essenziali sull&apos;uso del sito al proprietario del sito stesso, in questo caso il Titolare.
          </p>

          <p>
            I cookie possono essere memorizzati in modo permanente sul computer dell&apos;utente e avere una durata variabile (c.d. <em>cookie</em> persistenti),
            ma possono anche svanire con la chiusura del <em>browser</em> o avere una durata limitata (c.d. <em>cookie</em> di sessione).
          </p>

          <p>
            I cookie possono essere istallati dal Sito che l&apos;utente visita (c.d. <em>cookie</em> di prima parte) o possono essere istallati da altri siti web (c.d. <em>cookie</em> di terze parti)
          </p>

          <p>
            I <em>cookie</em> sono usati per differenti finalità, quali la esecuzione di autenticazioni informatiche, monitoraggio di sessioni,
            memorizzazione di informazioni su specifiche configurazioni riguardanti gli utenti che accedono al server, ecc.
          </p>
        </section>

        <section>
          <h2>
            Tipologie di Cookie utilizzati e relative finalità
          </h2>

          <p>
            I Siti utilizzano le seguenti tipologie di cookie:
          </p>

          <ul>
            <li>
              <em>cookie </em>di navigazione o di sessione, che garantiscono la normale navigazione e fruizione del sito web;
            </li>
            <li>
              <em>cookie analytics</em>, assimilati ai cookie tecnici laddove utilizzati direttamente dal gestore del sito per raccogliere informazioni,
              in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso;
            </li>
            <li>
              <em>cookie</em> di funzionalità, che permettono all&apos;utente la navigazione in funzione di una serie di criteri selezionati al fine di migliorare il servizio reso allo stesso.
            </li>
          </ul>

          <p>
            Questi <em>cookie</em> sono utilizzati da <em>Google Analytics</em> per effettuare analisi statistiche sulle modalità di navigazione degli utenti sui Siti,
            come ad esempio numero di pagine visitate, numero di click effettuati su pagina.
          </p>

          <p>
            Tuttavia se si preferisce non ricevere i <em>cookie</em>, si può modificare l&apos;impostazione del proprio <em>browser</em>
            in modo tale da essere avvisati della presenza dei <em>cookie</em>, dunque scegliere se accettarli o meno.
          </p>
        </section>

        <section>
          <h2>
            Gestione delle preferenze sui cookie
          </h2>

          <p>
            Al momento del primo accesso a qualunque pagina del Sito, è presente un banner che contiene una informativa breve.
            Proseguendo la navigazione, mediante l&apos;accesso ad altra area dei Siti o la selezione di un elemento degli stessi (ad esempio, di un link),
            l&apos;utente fornisce il consenso all&apos;uso dei <em>cookie</em>. Il consenso all&apos;uso dei cookie è registrato con un &quot;<em>cookie</em> tecnico&quot;.
          </p>

          <p>
            La continuazione della navigazione mediante l&apos;uscita dalla presente cookie policy in assenza di una specifica scelta di gestione dei consensi, equivale al conferimento di un consenso all&apos;utilizzo di tutti i cookie.
          </p>
        </section>

        <section>
          <h2>
            Come disabilitare e cancellare i cookie
          </h2>

          <p>
            Se si desidera disabilitare i <em>cookie</em>, è sufficiente aggiornare le impostazioni sulla <em>privacy</em> nelle impostazioni di configurazione del <em>browser</em>.
            La maggior parte dei <em>browser</em> è configurata per accettare, controllare o eventualmente disabilitare i <em>cookie</em> attraverso le impostazioni.
            Il Titolare ricorda tuttavia che disabilitare i <em>cookie</em> di navigazione o quelli funzionali può causare un insoddisfacente
            funzionamento del Sito e/o limitare il servizio offerto dal Titolare.
          </p>

          <p>
            Qui sotto il percorso da seguire per gestire ed eventualmente eliminare i cookie dai seguenti <em>browser</em>:
          </p>

          <ul>
            <li>
              <a
                href="https://support.microsoft.com/windows"
                rel="nofollow"
              >
                Internet Explorer
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/kb/PH19255"
                rel="nofollow"
              >
                Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647?hl=it-IT&hlrm=fr&hlrm=en"
                rel="nofollow"
              >
                Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop?redirectslug=Attivare+e+disattivare+i+cookie&redirectlocale=it"
                rel="nofollow"
              >
                Firefox
              </a>
            </li>
          </ul>

          <p>
            Dopo queste operazioni, tuttavia, alcune funzioni delle pagine web potrebbero non essere eseguite correttamente.
          </p>
        </section>

        <section>
          <h2>
            Comunicazione e diffusione dei dati
          </h2>

          <p>
            I dati raccolti utilizzando i <em>cookie </em>potranno essere trattati da dipendenti e collaboratori del Titolare in qualità di soggetti autorizzati al trattamento e/o amministratori di sistema.
          </p>

          <p>
            Tali dati potranno essere inoltre trattati da società e/o soggetti incaricati dal Titolare per svolgere compiti di natura tecnica ed organizzativa.
            Queste società sono dirette collaboratrici e svolgono la funzione di responsabile del trattamento.
            Il loro elenco è costantemente aggiornato ed è disponibile su richiesta inviando una comunicazione
            all&apos;indirizzo sotto indicato ovvero un&apos;e-mail a <a href="mailto:privacy@dove.it">privacy@dove.it</a>.
          </p>

          <p>
            I dati raccolti utilizzando i <em>cookie</em> non saranno ceduti a terzi.
          </p>

          <p>
            I dati raccolti utilizzando i <em>cookie</em> di Google potranno essere trasferiti da tale terza parte fuori dall&apos;Unione Europea,
            in particolare negli Stati Uniti d&apos;America, conformemente alla Normativa Privacy. In ogni caso, per ulteriori informazioni si prega di visitare
            la relativa <em>cookie policy</em> di Google.
          </p>

          <p>
            I dati raccolti utilizzando i <em>cookie </em>non saranno diffusi.
          </p>
        </section>

        <section>
          <h2>
            Tempi di conservazione
          </h2>

          <p>
            I dati sono conservati per il tempo indicato nella seguente tabella:
          </p>

          <table>
            <thead>
              <tr>
                <td>
                  TIPOLOGIA COOKIE
                </td>
                <td>
                  TEMPI DI CONSERVAZIONE
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Cookie tecnici
                </td>
                <td>
                  Validi per la sessione di navigazione
                </td>
              </tr>
              <tr>
                <td>
                  Cookie analytics
                </td>
                <td>
                  Stabiliti da terze parti, si rimanda alla loro informativa
                </td>
              </tr>
              <tr>
                <td>
                  Cookie di funzionalità
                </td>
                <td>
                  7 giorni
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            e comunque finché non venga espressamente esercitato il diritto di opposizione da parte dell&apos;interessato.
          </p>
        </section>

        <section>
          <h2>
            Esercizio diritti dell&apos;utente
          </h2>

          <p>
            L&apos;Utente potrà in qualsiasi momento esercitare i propri diritti inviando:
          </p>

          <ul>
            <li>
              una e-mail all&apos;indirizzo <a href="mailto:privacy@dove.it">privacy@dove.it</a>;
            </li>
            <li>
              una raccomandata a.r. a DOVE.IT, Via Nino Bixio, 7 - 20129 Milano.
            </li>
          </ul>

          <p>
            Per ulteriori informazioni si rinvia alla Privacy Policy consultabile <Link href="/privacy-policy">qui</Link>.
          </p>
        </section>
      </div>
    </Terms>
  </AppLayout>
);
